import { ShieldCheck } from "lucide-react";

const STEPS = [
  {
    n: "01",
    title: "Margin Expansion Map",
    body: "You receive a map of opportunities, an ROI estimate on each, and a recommended roadmap.",
    guarantee: true,
  },
  {
    n: "02",
    title: "Rollout",
    body: "You get working AI rolled out in your operations, with your team trained to use it.",
  },
  {
    n: "03",
    title: "Yours to Run",
    body: "You own everything we build. Optional support, on your terms.",
  },
] as const;

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="section-padding bg-background">
      <div className="section-container">
        {/* Heading */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-sm font-semibold uppercase tracking-wider text-gold mb-4 block">
            How It Works
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif leading-tight mb-5">
            Three Steps to Measurable Results
          </h2>
          <p className="text-lg text-body-gray">
            An audit that pays for itself, an implementation sized to your ops,
            and full ownership at handoff
          </p>
        </div>

        {/* Steps */}
        <div className="relative max-w-6xl mx-auto">
          {/* Connector line — desktop only, behind the cards */}
          <div className="hidden lg:block absolute top-8 left-[16.66%] right-[16.66%] h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-8 relative">
            {STEPS.map((step) => (
              <div
                key={step.n}
                className="relative flex flex-col items-start max-w-lg mx-auto lg:max-w-none lg:mx-0 w-full">
                {/* Numbered badge */}
                <div className="relative z-10 mb-6">
                  <div className="w-16 h-16 rounded-full bg-navy text-navy-foreground flex items-center justify-center font-serif text-2xl shadow-md">
                    {step.n}
                  </div>
                </div>

                {/* Title */}
                <h3 className="text-2xl lg:text-3xl font-serif text-navy mb-4 leading-tight">
                  {step.title}
                </h3>

                {/* Body */}
                <p className="text-body-gray leading-relaxed mb-4">
                  {step.body}
                </p>

                {/* Guarantee callout (Step 1) */}
                {step.guarantee && (
                  <div className="mt-4 inline-flex items-start gap-3 p-4 rounded-lg bg-gold/10 border border-gold/30 w-full">
                    <ShieldCheck className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" />
                    <p className="text-sm text-navy">
                      <span className="font-semibold">Our guarantee:</span>{" "}
                      $50,000+ in identified annual savings, or you pay nothing.
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
